import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const router = new VueRouter({
  routes: [
    { path: '/login', component: () => import(/* webpackChunkName: "Login" */'../views/Login.vue'), name:'Login'},
    { path: '/', component: () => import(/* webpackChunkName: "Home" */'../views/Home.vue'), name:'Home'},
    { path: '/play/:uuid', component: () => import(/* webpackChunkName: "Play" */'../views/Play.vue'), name:'Play' },
    { path: '/winner/:uuid', component: ()=> import(/* webpackChunkName: "Winner" */'../views/Winner.vue'), name:'Winner'}
  ],
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return savedPosition ? savedPosition : { x: 0, y: 0 }
  }
});

export default router